interface Props {
  className: any;
}

export const Swapicon = ({ className }: Props): JSX.Element => {
  return (
    <svg
      className={`${className}`}
      fill="none"
      height="42"
      viewBox="0 0 42 42"
      width="42"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M5.62496 19.2916L35.0083 10.75L33.6416 6.30829C33.1291 4.59996 31.25 3.57496 29.3708 4.08746L6.30829 10.9208C4.59996 11.4333 3.57496 13.3125 4.08746 15.1916L5.62496 19.2916ZM5.62496 19.2916L36.375 19.2917V32.9584C36.375 33.8645 36.0151 34.7336 35.3743 35.3743C34.7336 36.0151 33.8645 36.375 32.9584 36.375H9.04171C8.13555 36.375 7.26651 36.0151 6.62576 35.3743C5.98501 34.7336 5.62504 33.8645 5.62504 32.9584L5.62496 19.2916ZM11.092 9.55429L16.3879 16.2168M21.6832 6.30821L26.979 13.1415"
        stroke="#657D84"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="2"
      />
    </svg>
  );
}; 